import { InsuranceOptionModel } from "./InsuranceOptionModel"

export class InsuranceOfferModel {
    liabilityLimit: number
    options: InsuranceOptionModel[]
}